import { FC } from 'react';
import { GridFilterItem } from '../common/grid/GridFilterItem';
import { invitationListActions, InvitationListFilter, selectInvitationList } from '../../store/entities/invitationList';
import { GridFilterDateFromTo } from '../common/grid/GridFilterDateFromTo';
import { GridFilterInvitationState } from '../common/grid/GridFilterInvitationState';
import { EmployeeWrapper } from '../common/grid/GridFilterEmployee';
import { GridFilterSupplierEmployee } from '../common/grid/GridFilterSupplierEmployee';
import { hasOtherRoleThan, isExternal } from '../../utils/roles';
import { useAppSelector } from '../../store';
import { selectIdentity } from '../../store/entities/identity';
import { InvitationFilterSupplier } from './InvitationFilterSupplier';
import { InvitationFilterValidTo } from './InvitationFilterValidTo';
import { GridFilterInvitationWorkerStatus } from '../common/grid/GridFilterInvitationWorkerStatus';
import { GridFilterInvitationType } from '../common/grid/GridFilterInvitationType';
import { SupplierEmployeeDto } from '@api/models/suppliers/SupplierEmployeeDto';
import { UserRole } from '@api/models/enums/UserRole';

interface SupplierEmployeeWrapperProps {
  value?: SupplierEmployeeDto;
  onChange: (value?: SupplierEmployeeDto) => void;
}

const SupplierEmployeeWrapper: FC<SupplierEmployeeWrapperProps> = ({ value, onChange }) => {
  const invitationList = useAppSelector(selectInvitationList);

  return <GridFilterSupplierEmployee supplierId={invitationList.query.supplier?.id} value={value} onChange={onChange} />;
};

interface Props {
  query: InvitationListFilter;
}

export const InvitationFilter: FC<Props> = ({ query }) => {
  const identity = useAppSelector(selectIdentity);

  return (
    <>
      {!isExternal(identity) && <InvitationFilterSupplier query={query} />}

      {hasOtherRoleThan(identity.roles, [UserRole.ExternalWorker, UserRole.ExternalOneTime]) && (
        <GridFilterItem
          query={query}
          gridActions={invitationListActions}
          name="supplierEmployee"
          title="invitation.supplierEmployee"
          disableAutoClose={true}
          Component={SupplierEmployeeWrapper}
        />
      )}

      {!isExternal(identity) && (
        <GridFilterItem
          query={query}
          gridActions={invitationListActions}
          name="employee"
          title="invitation.employee"
          disableAutoClose={true}
          Component={EmployeeWrapper}
        />
      )}

      <GridFilterItem
        query={query}
        gridActions={invitationListActions}
        name="validFrom"
        title="invitation.validFrom"
        disableAutoClose={true}
        Component={GridFilterDateFromTo}
      />
      <InvitationFilterValidTo query={query} />
      <GridFilterItem
        query={query}
        gridActions={invitationListActions}
        name="invitationTypes"
        title="invitation.invitationType"
        disableAutoClose={true}
        Component={GridFilterInvitationType}
      />
      <GridFilterItem
        query={query}
        gridActions={invitationListActions}
        name="workerStatus"
        title="invitation.invitationWorkerState"
        disableAutoClose={true}
        Component={GridFilterInvitationWorkerStatus}
      />
      <GridFilterItem
        query={query}
        gridActions={invitationListActions}
        name="state"
        title="invitation.state"
        disableAutoClose={true}
        Component={GridFilterInvitationState}
      />
    </>
  );
};
